import { render, staticRenderFns } from "./basic-data-partial.vue?vue&type=template&id=69f58406"
import script from "./basic-data-partial.vue?vue&type=script&lang=js"
export * from "./basic-data-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports